module.exports = __webpack_public_path__ + "static/media/HTC One M8 Gold.b955d80e.png";